import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import useTheme from "../hooks/useTheme";
import ConfigContext from "./../ConfigProvider";
import IconInformation16pxBoldDarkS from "./../IconInformation16pxBoldDarkS/index";
import IconInformation16pxBoldLightS from "./../IconInformation16pxBoldLightS/index";
import { jsx as _jsx } from "react/jsx-runtime";
export var IconInformation16pxBoldS = function IconInformation16pxBoldS(props) {
  var _React$useContext = React.useContext(ConfigContext),
    theme = _React$useContext.theme;
  var _useTheme = useTheme(!theme),
    _useTheme2 = _slicedToArray(_useTheme, 1),
    nTheme = _useTheme2[0];
  var mergeTheme = theme || (nTheme === null || nTheme === void 0 ? void 0 : nTheme.theme);
  return mergeTheme === 'dark' ? /*#__PURE__*/_jsx(IconInformation16pxBoldDarkS, _objectSpread({}, props)) : /*#__PURE__*/_jsx(IconInformation16pxBoldLightS, _objectSpread({}, props));
};
export default IconInformation16pxBoldS;